import { IWavesAppDetection } from './interfaces';
import { getQueryString } from '../../../../domain/url-provider';
import { get, post } from '../../../../DAL/data-provider';

export const WAVES_APP_DEFAULT_LOGIN_ERR = 'Login failed, please try again.';

/**
 * detects waves app in URL query string, and parses the URL
 */
export const detectWavesApp = () : IWavesAppDetection => {

    const res = {
        isWavesApp: false,
        hasError: false,
    };

    const qs = getQueryString();
    if(!qs) return res;

    // this array will contain all query string except 'logintoken'
    // that is used for waves apps login
    const remainQS = [];

    let loginToken = '';

    // loop through the query string
    for (const [key, value] of Object.entries(qs)) {

        if(key.trim().toLowerCase() !== 'logintoken'){
            remainQS.push(`${key}=${value}`);
        }
        else{
            loginToken = value;
        }
    }

    // 'logintoken' is not found in query string ---> wavesapp is not detected
    if(!loginToken) return res;

    // parse login token --------------------------

    let [uuid, mac, ts, appCode, version, port] = ['', '', '', '', '', ''];

    try{
        [uuid, mac, ts, appCode, version, port] = window.atob(loginToken).split(',');
    }
    catch(ex){}

    const tsNum = Number(ts) ?? 0;

    // remove loginToken querystring from URL bar
    const url = window.location.href.replace(window.location.search, '');
    const updatedURL = remainQS.length > 0 ? `${ url }?${remainQS.join('?')}` : url;
    window.history.replaceState({}, document.title, updatedURL);

    const hasError = !uuid || uuid.length <= 0 || tsNum <= 0 || !appCode || appCode.length <= 0;

    return {
        isWavesApp: true,
        hasError,
        uuid,
        mac,
        ts: tsNum,
        appCode,
        version,
        qs: loginToken,
        port,
    }
};

export const getWavesAppData = async (appCode: string, timeToken: number, isLoggedIn = false, loginToken = '') => {

    return post('/api/membership/waves-app-data', {
        appCode,
        timeToken,

        // already logged in
        isLoggedIn,
        loginToken,
    });
};

export const getAppSuccessCallback = (
    successCallback: string,
    wavesAppLoginToken: string,
    port: string
) => {
    try{
        // parse current page url
        const currentPageUrl = new URL(window.location.href);
        let successCallbackUrlDecoded = decodeURIComponent(successCallback);
        successCallbackUrlDecoded = successCallbackUrlDecoded.replaceAll('{port}', port);

        // parse success callback url
        const successCallbackUrl = new URL(successCallbackUrlDecoded);
        for(const [key, value] of successCallbackUrl.searchParams) {
            if(!value.startsWith('{')) continue;

            if(value.toLowerCase() === '{logintoken}') {
                successCallbackUrl.searchParams.set(key, wavesAppLoginToken);
                continue;
            }

            if(value.toLowerCase() === '{port}') {
                successCallbackUrl.searchParams.set(key, port);
                continue;
            }

            // check if param exists in the current query string ---> replace
            if(currentPageUrl.searchParams.has(key)) {
                successCallbackUrl.searchParams.set(key, currentPageUrl.searchParams.get(key) || '');
            }
        }

        return decodeURIComponent(successCallbackUrl.toString());
    }
    catch (ex) {
        console.log(ex);
        return '';
    }
};

/*
export const getAppSuccessCallback = (
    successCallback: string,
    wavesAppLoginToken: string,
    port: string
) => {
    const url = decodeURIComponent(successCallback)
        .replaceAll('{LoginToken}', wavesAppLoginToken)
        .replaceAll('{port}', port);

    console.log('url', url);

    // http://localhost:{port}/login/update_login?loginToken={LoginToken}&success=true
    return url;
};*/


/**
 * after successful request
 */
export const handleAppSuccess = async (
    callbackTypeID: string | number,
    url: string
) : Promise<void> => {
    return new Promise(async (resolve, reject) => {
        if(callbackTypeID.toString() === '2'){
            // used for cosmos
            // in case of cosmos: perform an ajax
            try{
                const response = await get(url);
                if(response?.data?.is_succeeded){
                    window.close();
                }
                else{
                    reject();
                }
                /*
                const response = await fetch(url);
                const json = await response.json();
                if(json.is_succeeded){
                    window.close();
                }
                else{
                    reject();
                }*/
            }
            catch(ex){
                console.log('Cosmos ajax error:', ex);
            }
        }
        else{
            /*
            try{
                window.close();
            }
            catch(ex){ }*/

            // used for central
            // waves-central://login/success?loginToken={LoginToken}
            openApp(url);
        }

        resolve();
    });
};

/**
 * open app with custom protocol
 */
export const openApp = (url: string) => {

    console.log('Open app url:', url);

    const $link = document.createElement('a');
    $link.id = 'waves-app-custom-protocol';
    $link.href = url;
    $link.style.display = 'none';

    document.body.appendChild($link);
    $link.click();
    $link.remove();
};
